module.exports = __webpack_public_path__ + "img/block_1.d3a8816c.webp";